import {StyleSheet, Text, View, Switch, Pressable} from 'react-native';
import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {useTheme} from "@react-navigation/native";

export const SettingsItem = (props) => {
    const dispatch = useDispatch();
    const theme= useTheme();
    const [isEnabled, setIsEnabled] = useState(props.enabled);
    const toggleSwitch = () => {
        setIsEnabled(previousState => !previousState);
        dispatch({type: 'CHANGE_SETTINGS', payload: {id: props.prop, enabled: !isEnabled}})
        dispatch({type: 'SAVE_SETTINGS', payload:[]});
    }

    const styles = StyleSheet.create({
        settingsItemWrapper: {
            width: '100%',
            maxWidth: 800,
            padding: 12,
            display:'flex',
            flexDirection:'row',
            flexWrap:'nowrap',
            fontFamily: 'Roboto-Regular'
        },
        settingsTitle: {
            display:'flex',
            flexDirection:'column',
            paddingHorizontal:12,
            width:'90%'
        }
    });
    return(
        <View style={styles.settingsItemWrapper}>
            <Switch
                trackColor = {{false: theme.colors.scheme[4], true: theme.colors.scheme[1]}}
                thumbColor = {theme.colors.scheme[4]}
                activeThumbColor ={theme.colors.scheme[1]}
                ios_backgroundColor={theme.colors.scheme[4]}
                onValueChange={toggleSwitch}
                value={isEnabled}
            />
            <Pressable style={styles.settingsTitle} onPress={toggleSwitch}>
                <Text style={{fontWeight:'bold', color:theme.colors.scheme[2]}}>{props.title}</Text>
                <Text style={{color:theme.colors.scheme[2]}}>{props.description}</Text>
            </Pressable>
        </View>
    );
}